// import actions
import facturacionAction from './actions/facturacion'

// import getters

// import mutations

// import states

const actions = { ...facturacionAction }

const getters = { }

const mutations = { }

const state = { }

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
}
